import React, { useEffect, useState, useContext } from 'react';
import { FormField } from '../../uiwidgets/FormField';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { SubmitButton } from '../../uiwidgets/SubmitButton';
import { Row, Col, Spinner, Alert } from 'react-bootstrap';
import { CancelButton } from 'uiwidgets/CancelButton';
import PageContentContainer from 'uiwidgets/PageContentContainer';
import { extractError } from 'api/ErrorUtil';
import { API } from 'api/API';
import { BUSINESS_MESSAGES_URL } from 'config/config';
import { TenantContext } from '../../tenant/TenantContext';
import { containsAlphaNumAndSpaceAndPunctuationOnly } from 'util/Validators';

const BusinessMessages = () => {
  const initialState = {
    errors: {},
    infoMessage: "",
    readOnly: false
  }
  const initialValidationState = {
    termsAndConditionsError: false,
    termsAndConditionsErrMsg: "",
    billMessageError: false,
    billMessageErrMsg: "",
    receiptMessageError: false,
    receiptMessageErrMsg: "",
    offlinePaymentEmailMessageError: false,
    offlinePaymentEmailMessageErrMsg: ""
  }

  const messageReset = () => {
    return {
      infoMessage: "",
      errors: {}
    }
  }

  const onToastClose = () => {
    setFormData({
      ...formData,
      ...messageReset()
    });
  }

  const [formData, setFormData] = useState(initialState);
  const [formValidityData, setFormValidityData] = useState(initialValidationState);
  const { businessConfig } = useContext(TenantContext);

  const fetchBusinessProfile = React.useCallback(async () => {
    try {
      let businessMessages = await API.get(BUSINESS_MESSAGES_URL);
      setFormData({ ...businessMessages.data });
    } catch (error) {
      let exError = extractError(error);
      setFormData({
        ...formData,
        errors: exError
      });
    }
  });

  useEffect(() => {
    fetchBusinessProfile();
  }, []);

  const handleCancel = (event) => {

  }

  const handleChange = (event) => {
    if (formData.readOnly) {
      return;
    }
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setFormData({
      ...formData,
      [name]: value
    })

  }

  const handleValidation = (event) => {
    if (formData.readOnly) {
      return;
    }
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    let { hasError, error } = validateInput(name, value);
    setFormValidityData({
      ...formValidityData,
      [name + 'Error']: hasError,
      [name + 'ErrMsg']: error
    })
  }

  const validateInput = (name, value) => {
    let hasError = false,
      error = ""
    switch (name) {
      case "termsAndConditions":
        if (value.trim() === "") {
          hasError = false;
        } else if (!containsAlphaNumAndSpaceAndPunctuationOnly(value)) {
          hasError = true
          error = "Terms and Conditions can only contain alpha-numeric characters, space and punctuations";
        } else {
          hasError = false
          error = ""
        }
        break;
      case "receiptMessage":
        if (value.trim() === "") {
          hasError = false;
        } else if (!containsAlphaNumAndSpaceAndPunctuationOnly(value)) {
          hasError = true
          error = "Receipt Message can only contain alpha-numeric characters, spaces and punctuations";
        } else {
          hasError = false
          error = ""
        }
        break;
      case "billMessage":
        if (value.trim() === "") {
          hasError = false;
        } else if (!containsAlphaNumAndSpaceAndPunctuationOnly(value)) {
          hasError = true
          error = "Bill Message can only contain alpha-numeric characters, spaces and punctuations";
        } else {
          hasError = false
          error = ""
        }
        break;
      case "offlinePaymentEmailMessage":
        if (value.trim() === "") {
          hasError = false;
        } else if (!containsAlphaNumAndSpaceAndPunctuationOnly(value)) {
          hasError = true
          error = "Offline Payment Message can only contain alpha-numeric characters, spaces and punctuations";
        } else {
          hasError = false
          error = ""
        }
        break;
      default:
        break;
    }
    return { hasError, error };
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    const tagNames = ['select', 'input', 'textarea'];
    for (let tagName of tagNames) {
      //validate full form
      for (let i = 0; i < event.target.getElementsByTagName(tagName).length; i++) {
        let fieldName = event.target.getElementsByTagName(tagName)[i].name;
        let fieldValue = event.target.getElementsByTagName(tagName)[i].value;
        let valResult = validateInput(fieldName, fieldValue);
        setFormValidityData({
          ...formValidityData,
          [fieldName + 'Error']: valResult.hasError,
          [fieldName + 'ErrMsg']: valResult.error
        })
        if (valResult.hasError) {
          alert("Form has validation error")
          return false;
        }
      }
    }

    if (!formData.termsAndConditions && !formData.billMessage && !formData.receiptMessage && !formData.offlinePaymentEmailMessage) {
      alert("Atleast one of the fields must be populated to to save")
      return false;
    }

    try {
      let response = await API.put(BUSINESS_MESSAGES_URL, { ...formData, businessId: businessConfig.business_id });
      setFormData({
        ...formData,
        ...response.data,
        infoMessage: "Messages were saved successfully",
        errors: {}
      });
    } catch (error) {
      let exError = extractError(error);
      setFormData({
        ...formData,
        infoMessage: "",
        errors: exError
      });
    }
  }

  return (
    <>
      {formData.status && <PageContentContainer><Alert key="info" variant='info'>
        <Spinner animation="border" role="status" variant='dark' className="me-4" />
        {formData.status}
      </Alert></PageContentContainer>}
      <FormContainer title="Business Profile" submitButtonFunction={handleSubmit}
        errors={formData.errors} infoMessage={formData.infoMessage} toastCloseFunc={onToastClose}>
        <Row>
          <Col>
            <FormField name="termsAndConditions" label="Terms and Conditions" type="textarea"
              value={formData.termsAndConditions}
              placeholder="Terms And Conditions" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.termsAndConditionsError} valMsg={formValidityData.termsAndConditionsErrMsg}
              readOnly={formData.readOnly} style={{ height: "150px" }} />
          </Col>
        </Row>

        <Row>
          <Col>
            <FormField name="receiptMessage" label="Receipt Message" type="textarea"
              value={formData.receiptMessage}
              placeholder="Receipt Message" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.receiptMessageError} valMsg={formValidityData.receiptMessageErrMsg}
              readOnly={formData.readOnly} style={{ height: "100px" }} />
          </Col>
        </Row>
        {businessConfig.appFeatures.includes('BILLING') && 
        <Row>
          <Col>
            <FormField name="billMessage" label="Bill Message" type="textarea" value={formData.billMessage}
              placeholder="Bill Message" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.billMessageError} valMsg={formValidityData.billMessageErrMsg}
              readOnly={formData.readOnly} style={{ height: "100px" }} />
          </Col>
        </Row>}
        <Row><Col>&nbsp;</Col></Row>
        <Row>
          <Col>
            <FormField name="offlinePaymentEmailMessage" label="Offline Payment Message" type="textarea" value={formData.offlinePaymentEmailMessage}
              placeholder="Offline Payment Message" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.offlinePaymentEmailMessageError} valMsg={formValidityData.offlinePaymentEmailMessageErrMsg}
              readOnly={formData.readOnly} style={{ height: "200px" }} />
          </Col>
        </Row>
        <Row><Col>&nbsp;</Col></Row>
        <Row><Col>
          <SubmitButton label='Save' disabled={formData.readOnly} className="me-2" />
        </Col>
        </Row>
      </FormContainer>
    </>
  )
}

export default BusinessMessages;